import axios from 'axios';
import { storage } from 'utils/appLocalStorage';

const getBackendUrl = () => {
  if (
    window.location.hostname === 'localhost' &&
    window.location.port === '3000'
  ) {
    return 'http://localhost:3333';
  }

  return 'https://api.pro.agroger.com.br';
};

export const downloadXmlNota = async (chave) => {
  const token = localStorage.getItem(storage.token);

  if (!token) {
    throw new Error(
      'Token de autenticação não encontrado. Faça login novamente.',
    );
  }

  try {
    const backendUrl = getBackendUrl();

    const response = await fetch(
      `${backendUrl}/v1/nfe/chave/${chave}/xml/download`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/xml', // ← Importante!
        },
      },
    );

    if (response.ok) {
      const blob = await response.blob();

      return blob;
    }

    throw new Error('Erro ao baixar XML');
  } catch (localError) {
    try {
      const productionApiUrl = 'https://api.pro.agroger.com.br';

      const tempInstance = axios.create({
        baseURL: productionApiUrl,
        timeout: 30000,
      });

      if (token) {
        tempInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
        tempInstance.defaults.headers.common.Accept = 'application/xml';
      }

      const response = await tempInstance.get(
        `/v1/nfe/chave/${chave}/xml/download`,
      );

      if (response.status === 200) {
        const blob = new Blob([response.data], { type: 'application/xml' });

        return blob;
      }

      throw new Error('Erro ao baixar XML');
    } catch (productionError) {
      throw new Error(
        'Não foi possível baixar o XML. Verifique sua conexão e permissões.',
      );
    }
  }
};

export class NfeFactory {
  constructor(instance) {
    this.instance = instance;
  }

  salvarCertificado(formData) {
    return this.instance.post('/v1/nfe/certificados/consulta', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  consultarSefaz(data) {
    return this.instance.post('/v1/nfe/consultar', data, {
      headers: {
        'Content-Type': 'application/json',
      },
      timeout: 300000,
    });
  }

  consultar(data) {
    if (data.certificateId) {
      return this.instance.post(
        '/v1/nfe/consultar',
        {
          certificateId: data.certificateId,
          nsu: data.nsu,
          chave: data.chave,
          tipoConsulta: data.tipoConsulta,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
    }

    const formData = new FormData();
    formData.append('certificado', data.certificado);
    formData.append('senha', data.senha);
    if (data.nsu) {
      formData.append('nsu', data.nsu);
    }
    if (data.chave) {
      formData.append('chave', data.chave);
    }
    if (data.tipoConsulta) {
      formData.append('tipoConsulta', data.tipoConsulta);
    }
    return this.instance.post('/v1/nfe/certificados/consulta', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  listar(params) {
    return this.instance.get('/v1/nfe/notas', { params });
  }

  manifestar(data) {
    return this.instance.post('/v1/nfe/manifestar', data);
  }

  atualizarXml(chave, certificateId) {
    return this.instance.post('/v1/nfe/manifestar/atualizar-xml', {
      chave,
      certificateId,
    });
  }

  listarPendentesManifestacao() {
    return this.instance.get('/v1/nfe/notas/pendentes-manifestacao');
  }

  verificarDisponibilidadeXml(chave) {
    return this.instance.get(`/v1/nfe/notas/verificar-xml/${chave}`);
  }

  static downloadXml(chave) {
    return downloadXmlNota(chave);
  }
}
